<template>
    <div class="maintain">
        <el-alert :closable="false" title=" 请您遵守国家相关规定，切勿上传低俗色情、暴力恐怖、谣言诈骗、侵权盗版等相关内容，资鲸保有依据国家规定及平台规则进行处理的权利。" type="warning" show-icon></el-alert>
        <div class="plateBox">
            <div class="title">基本信息</div>
            <div class="item">
                <div class="left">机构logo</div>
                <div class="right">
                    <div class="content">
                        <img class="logo" v-if="data.shoplogourl" :src="data.shoplogourl+'?'+timestamp" alt="">
                        <div v-else>--</div>
                    </div>
                    <div class="setBtn" @click="handSetLogo">设置</div>
                </div>
            </div>
            <div class="item center">
                <div class="left">机构名称</div>
                <div class="right">
                    <div class="content">
                        <div v-if="data.hostname">{{data.hostname}}</div>
                        <div v-else>--</div>
                    </div>
                    <div class="setBtn" @click="handSetName">设置</div>
                </div>
            </div>
            <div class="item">
                <div class="left">机构封面图</div>
                <div class="right">
                    <div class="content">
                        <img class="coverImg" v-if="data.mobshopbgurl" :src="data.mobshopbgurl+'?'+timestamp" alt="">
                        <div v-else>--</div>
                    </div>
                    <div class="setBtn" @click="handSetCoverImg">设置</div>
                </div>
            </div>
            <div class="item">
                <div class="left">机构简介</div>
                <div class="right">
                    <div class="content">
                        <div class="desp" v-if="data.shopmemo">{{data.shopmemo}}</div>
                        <div v-else>--</div>
                    </div>
                    <div class="setBtn" @click="handSetDesp">设置</div>
                </div>
            </div>
        </div>
        <div class="plateBox">
            <div class="title">机构主页分享</div>
            <div class="item">
                <div class="left paddingTop30">主页二维码</div>
                <div class="right">
                    <div class="content">
                        <img class="code" v-if="data.hostshareurl" :src="data.hostshareurlcode" alt="">
                        <div v-else>--</div>
                    </div>
                    <!-- <div class="setBtn" @click="handSetLogo">设置</div> -->
                </div>
            </div>
            <div class="item center">
                <div class="left">主页链接</div>
                <div class="right">
                    <div class="content">
                        <div v-if="data.hostshareurl">{{data.hostshareurl}}</div>
                        <div v-else>--</div>
                    </div>
                    <div class="setBtn hostshareurl" :data-clipboard-text="data.hostshareurl" @click="handCopyHostshareurl">复制链接</div>
                </div>
            </div>
        </div>
        <div class="plateBox">
            <div class="title">公众号信息</div>
            <div class="item center">
                <div class="left">公众号名称</div>
                <div class="right">
                    <div class="content">
                        <div v-if="data.subqrcodename">{{data.subqrcodename}}</div>
                        <div v-else>--</div>
                    </div>
                    <div class="setBtn" @click="handSetOfficalMsg">设置</div>
                </div>
            </div>
            <div class="item">
                <div class="left paddingTop30">公众号二维码</div>
                <div class="right">
                    <div class="content">
                        <img class="code" v-if="data.subqrcodeurl" :src="data.subqrcodeurl+'?'+timestamp" alt="">
                        <div v-else>--</div>
                    </div>
                    <!-- <div class="setBtn">设置</div> -->
                </div>
            </div>
        </div>
        <div class="plateBox">
            <div class="title">客服信息</div>
            <div class="item center">
                <div class="left">客服名称</div>
                <div class="right">
                    <div class="content">
                        <div v-if="data.servicename">{{data.servicename}}</div>
                        <div v-else>--</div>
                    </div>
                    <div class="setBtn" @click="handsetServiceMsg">设置</div>
                </div>
            </div>
            <div class="item center">
                <div class="left">联系电话</div>
                <div class="right">
                    <div class="content">
                        <div v-if="data.servicetel">{{data.servicetel}}</div>
                        <div v-else>--</div>
                    </div>
                    <!-- <div class="setBtn">设置</div> -->
                </div>
            </div>
            <div class="item">
                <div class="left paddingTop30">客服二维码</div>
                <div class="right">
                    <div class="content">
                        <img class="code" v-if="data.serviceqrcodeurl" :src="data.serviceqrcodeurl+'?'+timestamp" alt="">
                        <div v-else>--</div>
                    </div>
                    <!-- <div class="setBtn">设置</div> -->
                </div>
            </div>
        </div>
        <div class="plateBox">
            <div class="title">机构详情</div>
            <div class="item">
                <div class="left">关于我们</div>
                <div class="right aboutUs">
                    <div class="content">
                        <div class="aboutUsContent" v-if="data.shopdesp" v-html="data.shopdesp"></div>
                        <div v-else>--</div>
                    </div>
                    <div class="setBtn" @click="handleSetAboutUs">设置</div>
                </div>
            </div>
        </div>
        <setName ref="setName" :data="data" @setName="setName" />
        <setLogo ref="setLogo" :data="data" @setLogo="setLogo" />
        <setCoverImg ref="setCoverImg" :data="data" @setCoverImg="setCoverImg" />
        <setDesp ref="setDesp" :data="data" @setDesp="setDesp" />
        <setOfficalMsg ref="setOfficalMsg" :data="data" @setOfficalMsg="setOfficalMsg" />
        <setServiceMsg ref="setServiceMsg" :data="data" @setServiceMsg="setServiceMsg" />
        <setAboutUs ref="setAboutUs" :data="data" @setAboutUs="setAboutUs" />
    </div>
</template>
<script>
import {getShopSettingByCapwhale} from 'api/accountApi'
import {mapActions} from 'vuex'
import setName from './setName'
import setLogo from './setLogo'
import setCoverImg from './setCoverImg'
import setDesp from './setDesp'
import setOfficalMsg from './setOfficalMsg'
import setServiceMsg from './setServiceMsg'
import setAboutUs from './setAboutUs'
import {urlToQRCode} from '@/common/js/tools.js'
import Clipboard from 'clipboard'
export default {
    name: 'maintain',
    data() {
        return {
            data: {},
            timestamp: new Date().getTime(),
        }
    },
    created() {
        this.getShopSettingByCapwhale()
    },
    mounted() {

    },
    methods: {
        // 设置名称
        handSetName() {
            this.$refs.setName.open()
        },
        setName(e) {
            this.data.hostname = e
        },
        // 设置logo
        handSetLogo() {
            this.$refs.setLogo.open()
        },
        setLogo(e) {
            this.timestamp = new Date().getTime()
            this.data.shoplogourl = e.shoplogourl
            this.data.shoplogoid = e.shoplogoid
            console.log(this.timestamp)
        },
        // 设置封面图
        handSetCoverImg() {
            this.$refs.setCoverImg.open()
        },
        setCoverImg(e) {
            this.timestamp = new Date().getTime()
            this.data.mobshopbgid = e.mobshopbgid
            this.data.mobshopbgurl = e.mobshopbgurl
            console.log(e)
        },
        // 设置简介
        handSetDesp() {
            this.$refs.setDesp.open()
        },
        setDesp(e) {
            this.data.shopmemo = e
        },
        // 设置公众号信息
        handSetOfficalMsg() {
            this.$refs.setOfficalMsg.open()
        },
        setOfficalMsg(e) {
            this.timestamp = new Date().getTime()
            this.data.subqrcodeid = e.subqrcodeid ? e.subqrcodeid : ''
            this.data.subqrcodename = e.subqrcodename
            this.data.subqrcodeurl = e.subqrcodeurl ? e.subqrcodeurl : ''
        },
        // 设置客服信息
        handsetServiceMsg() {
            this.$refs.setServiceMsg.open()
        },
        setServiceMsg(e) {
            this.timestamp = new Date().getTime()
            this.data.servicename = e.servicename
            this.data.serviceqrcodeid = e.serviceqrcodeid ? e.serviceqrcodeid : ''
            this.data.serviceqrcodeurl = e.serviceqrcodeurl ? e.serviceqrcodeurl : ''
            this.data.servicetel = e.servicetel
            console.log(e)
        },
        // 设置关于我们
        handleSetAboutUs() {
            this.$refs.setAboutUs.open()
        },
        setAboutUs(e) {
            this.data.shopdesp = e
            console.log(e)
        },
        getShopSettingByCapwhale() {
            this.setLoading(true)
            let options = {}
            getShopSettingByCapwhale({
                data: options,
                success: res => {
                    this.setLoading(false)
                    res.data.hostshareurlcode = urlToQRCode(res.data.hostshareurl)
                    this.data = res.data
                    console.log(res)
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        // 复制链接
        handCopyHostshareurl() {
            var clipboard = new Clipboard('.hostshareurl')
            clipboard.on('success', e => {
                this.$message.success('复制成功')
                // 释放内存
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                // 不支持复制
                this.$message.warning('该浏览器不支持自动复制')
                // 释放内存
                clipboard.destroy()
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    components: {
        setName,
        setLogo,
        setCoverImg,
        setDesp,
        setOfficalMsg,
        setServiceMsg,
        setAboutUs
    }
}
</script>
<style lang="scss">
    .maintain {
        padding: 20px 30px;
        background: #fff;
        .el-alert {
            margin-bottom: 22px;
        }
        .plateBox {
            padding: 0 0 30px;
            .title {
                font-size: 16px;
                padding-left: 8px;
                border-left: 2px solid #409EFF;
                font-weight: bold;
                // margin-bottom: 20px;
            }
            .item {
                width: 100%;
                display: flex;
                align-items: flex-start;
                &.center {
                    align-items: center;
                }
                .left {
                    font-size: 14px;
                    color: #999999;
                    margin-right: 20px;
                    width: 84px;
                    padding: 20px 0;
                    &.paddingTop30 {
                        padding-top: 30px;
                    }
                }
                .right {
                    flex: 1;
                    padding: 20px 10px 20px 0;
                    border-bottom: 1px solid #DCDFE6;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .logo {
                        width: 80px;
                        height: 80px;
                    }
                    .setBtn {
                        font-size: 14px;
                        color: #409EFF;
                        cursor: pointer;
                    }
                    .coverImg {
                        width: 350px;
                        height: 50px;
                    }
                    .desp {
                        width: 710px;
                        font-size: 14px;
                        line-height: 20px;
                    }
                    .code {
                        width: 110px;
                        height: 110px;
                    }
                    &.aboutUs {
                        border-bottom: none;
                        align-items: flex-start;
                    }
                    .aboutUsContent {
                        width: 720px;
                        height: 500px;
                        overflow-y: scroll;
                        padding: 18px 20px;
                        box-sizing: border-box;
                        line-height: 24px;
                        border: 1px solid #E5E5E5;
                        img {
                            max-width: 680px;
                        }
                        strong {
                            font-weight: bold;
                        }
                    }
                }
            }
        }
    }
</style>